import { Navigate } from "react-router-dom";
import SessionContext from "app/contexts/SessionContext";
import { useContext } from "react";
import usePWA from "shared/hooks/ui/usePWA";

const Home = () => {
    const session = useContext(SessionContext);
    const isPWA = usePWA();

    let defaultPage = session?.defaultPage;

    let redirectTo = "/timesheets";

    // If running in PWA mode, redirect to DailyTimesheet
    if (isPWA) {
        redirectTo = "/DailyTimesheet";
    } else if (defaultPage && defaultPage.length > 0){
        redirectTo = defaultPage;
    } 

    return (
        <Navigate to={redirectTo} />
    );
};

export default Home;
